import * as React from "react";
import { LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";

export function Alert({
  variant = "info",
  title,
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  variant?: "info" | "warning" | "error" | "success";
  title?: string;
}) {
  return (
    <div
      role={variant === "error" ? "alert" : "status"}
      className={cn("vl-alert", `vl-alert-${variant}`, className)}
      {...props}
    >
      {title && <strong>{title}</strong>}
      {children}
    </div>
  );
}
export function Status({
  tone = "neutral",
  children,
  className,
}: {
  tone?: "neutral" | "success" | "warning" | "danger";
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span className={cn("vl-status", `vl-status-${tone}`, className)}>
      {children}
    </span>
  );
}
export function Loading({ label }: { label?: string }) {
  const { t } = useTranslation("ui");
  return (
    <div className="vl-loading" role="status">
      <LoaderCircle className="vl-spin" aria-hidden="true" size={16} />
      <span>{label || t("loading")}</span>
    </div>
  );
}
export function Empty({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="vl-empty">
      <h2>{title}</h2>
      {description && <p>{description}</p>}
      {children}
    </div>
  );
}
